<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1650px;">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.title"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group
              horizontal
              name="picture"
              attribute="attributes.picture"
              :label="$t('attributes.picture')"
              grouped
            >
              <b-dropdown v-model="form.picture" aria-role="list">
                <button class="button" type="button" slot="trigger">
                  <figure class="image">
                    <img
                      :src="CatalogClassImage(form.picture)"
                      :alt="form.picture_alt"
                      style="width: 25px; margin: auto;"
                    />
                  </figure>
                  <h3 style="margin-left: 4px;">{{ form.picture }}</h3>
                  <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item
                  v-for="option in iconOptions"
                  :value="option.icon"
                  :key="option.icon"
                  aria-role="listitem"
                >
                  <div class="media" style="align-items: center;">
                    <div class="media-left">
                      <figure class="image">
                        <img
                          :src="CatalogClassImage(option.icon)"
                          :alt="option.name"
                          style="width: 30px; margin: auto;"
                        />
                      </figure>
                    </div>
                    <div class="media-content">
                      <h3>{{ option.name }}</h3>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </form-group>

            <form-group horizontal name="url" :label="$t('attributes.url')">
              <b-input
                v-model="form.url"
                name="url"
                :placeholder="$t('message.please_input') + $t('attributes.url')"
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="selected_catalog"
              :label="$t('attributes.selected_catalogs')"
            >
              <div class="catalog-select-wrap-all mt-0">
                <div
                  v-for="option in postCatalogs"
                  :key="option.catalog_no"
                  class="column is-3 is-marginless is-selectable catalog-select-tag"
                >
                  <b-tag
                    attached
                    closable
                    aria-close-label="Close tag"
                    size="is-medium"
                    @close="
                      onRemoveSelectedCatalogs(option, form.selected_catalogs)
                    "
                  >
                    {{ !option.status ? '[下架]' : '' }}
                    {{ option.name }}
                  </b-tag>
                </div>
              </div>
            </form-group>
            <form-group
              horizontal
              name="area_code"
              attribute="attributes.area"
              :label="$t('attributes.area')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :loading="loadingAreas"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ !option.status ? '[下架]' : '' }}
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="catalog"
              :label="$t('attributes.catalog')"
            >
              <div class="catalog-select-wrap">
                <div class="columns is-multiline is-mobile">
                  <b-checkbox
                    v-if="catalogsList.length > 0"
                    v-model="showOffCatalogs"
                    class="column is-4 is-marginless"
                    @input="onShowOffCatalogs"
                  >
                    {{ $t('attributes.show_off_items') }}
                  </b-checkbox>
                </div>
                <div class="columns is-multiline is-mobile">
                  <b-checkbox
                    v-for="option in catalogsList"
                    v-model="form.selected_catalogs"
                    :key="option.catalog_no"
                    :native-value="option"
                    :disabled="
                      form.selected_catalogs.findIndex(
                        c => c.catalog_no === option.catalog_no
                      ) !== -1
                    "
                    class="column is-4 is-marginless is-selectable"
                    @input="selected => onSelectedCatalog(option, selected)"
                  >
                    {{ !option.status ? '[下架]' : '' }}
                    {{ option.name }}
                    <a
                      @click.prevent.stop="onUpdateSort(option)"
                      style="font-size: 14px; color: blue;"
                    >
                      {{ $t('attributes.sort') }}
                    </a>
                  </b-checkbox>
                </div>
              </div>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="sending"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              this.travelInfo.id
                ? $t('attributes.update')
                : $t('attributes.add')
            }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
    <b-modal
      :active.sync="isTravelInfoSortModelActive"
      :can-cancel="false"
      full-screen
      has-modal-card
    >
      <catalog-travel-information-from
        :catalog-no="selectedCatalogNo"
        :catalog-name="selectedCatalogName"
      />
    </b-modal>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import notifyService from '@/services/notifyService'
import { AREA_API } from '@/utils/apis'
import CatalogTravelInformationFrom from '@/components/catalogs/CatalogTravelInformationFrom'

export default {
  name: 'TravelInfoForm',
  components: { CatalogTravelInformationFrom },
  props: {
    travelInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    const iconOptions = [
      { name: 'icon-air-earth', icon: 'icon-air-earth' },
      { name: 'icon-air-earth-flag', icon: 'icon-air-earth-flag' },
      { name: 'icon-air-map', icon: 'icon-air-map' },
      { name: 'icon-air-money-change', icon: 'icon-air-money-change' },
      { name: 'icon-air-sing-in', icon: 'icon-air-sing-in' },
      { name: 'icon-air-weather', icon: 'icon-air-weather' },
      { name: 'icon-passport', icon: 'icon-passport' }
    ]

    return {
      loadingAreas: false,
      areas: [],
      selectedArea: null,
      selectedCatalog: null,

      sending: false,
      form: this.extractFormValues(this.travelInfo, iconOptions),

      iconOptions,

      isImageModalActive: false,
      selectedImageUrl: null,
      postCatalogs: this.travelInfo.catalogs ? this.travelInfo.catalogs : [],
      catalogsList: [],
      showOffCatalogs: false,
      selectedCatalogNo: '',
      selectedCatalogName: '',
      isTravelInfoSortModelActive: false
    }
  },
  validations: {
    form: {
      id: {},
      status: { required },
      title: { required, maxLength: maxLength(50) },
      picture: { required },
      url: { maxLength: maxLength(200) },
      selected_catalogs: { required }
    }
  },
  computed: {
    formTitle() {
      let title = this.travelInfo.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.travel_info')

      return title
    },
    isLoading() {
      return this.loadingAreas || this.sending
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.selectedArea = null

        if (this.form.area_code) {
          this.selectedArea = this.areas.find(
            a => a.code === this.form.area_code
          )
          if (this.selectedArea) {
            this.catalogs = this.selectedArea.catalogs
            this.catalogsList = this.showOffCatalogs
              ? this.catalogs
              : this.catalogs.filter(c => c.status === true)
          } else {
            this.catalogs = []
            this.catalogsList = []
          }
        }
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    onSelectArea(option) {
      this.selectedArea = option && option
      if (this.selectedArea) {
        this.catalogs = this.selectedArea.catalogs
        this.catalogsList = this.showOffCatalogs
          ? this.catalogs
          : this.catalogs.filter(c => c.status === true)
      } else {
        this.catalogs = []
        this.catalogsList = []
      }
    },
    onShowOffCatalogs(selected) {
      this.showOffCatalogs = !!selected
      this.catalogsList = this.showOffCatalogs
        ? this.catalogs
        : this.catalogs.filter(c => c.status === true)
    },
    onUpdateSort(data) {
      this.selectedCatalogNo = data.catalog_no
      this.selectedCatalogName = data.name
      this.isTravelInfoSortModelActive = true
    },
    onSelectedCatalog(catalog, selectedCatalogs) {
      let index = selectedCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      const selected = index !== -1

      index = this.postCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      if (index === -1) {
        this.postCatalogs = [...this.postCatalogs, catalog]
      }

      index = this.form.selected_catalogs.findIndex(
        z => z.catalog_no === catalog.catalog_no
      )
      if (selected) {
        if (index === -1) {
          this.form.selected_catalogs = [
            ...this.form.selected_catalogs,
            catalog
          ]
        }
      } else {
        if (index !== -1) {
          this.form.selected_catalogs.splice(index, 1)
        }
      }
    },
    onRemoveSelectedCatalogs(catalog, selectedCatalogs) {
      let index = selectedCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      selectedCatalogs.splice(index, 1)
      this.form.selected_catalogs = selectedCatalogs
      this.postCatalogs = selectedCatalogs
    },
    extractFormValues(data, iconOptions) {
      return {
        id: data.id,
        status: data.status,
        title: data.title,
        picture: data.picture || iconOptions[0].icon,
        url: data.url,
        selected_catalogs: data.catalogs === null ? [] : data.catalogs
      }
    },
    async onSend() {
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
